<template>
  <div>
    <div>
      <b-container class="bv-example-row">
        <div class="mt-15 container card_container">
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Codice fiscale</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="cf"
                placeholder="Codice Fiscale"
                value=""
                v-model="jsonData.codiceFiscale"
                style="text-transform: uppercase"
                :state="validationCodiceFiscale"
                maxlength="16"
                @keydown.space.prevent
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Tessera Sanitaria</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="cf"
                placeholder="Ultime 5 cifre codice tessera sanitaria"
                value=""
                v-model="jsonData.codiceTS"
                required
                :state="validationCodiceTs"
                maxlength="5"
                @keydown.space.prevent
              />
            </b-col>
          </b-row>
          <div v-if="codiceFiscaleInserito">
            <b-row>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px"><strong>Nome</strong></div>
                <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="nome"
                  placeholder="Nome"
                  value=""
                  v-model.trim="jsonData.nome"
                  disabled
                  style="text-transform: uppercase"
                />
              </b-col>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Cognome</strong>
                </div>
                <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="cognome"
                  placeholder="Cognome"
                  value=""
                  v-model.trim="jsonData.cognome"
                  disabled
                  style="text-transform: uppercase"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px"><strong>Data di nascita</strong></div>
                <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="datanascita"
                  placeholder="Data di nascita"
                  value=""
                  v-model="jsonData.dataNascita"
                  locale="it"
                  disabled
                />
              </b-col>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Luogo di nascita</strong>
                </div>
                <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="luogonascita"
                  value=""
                  v-model="jsonData.luogoDiNascita"
                  style="text-transform: uppercase"
                  disabled
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Sesso</strong>
                </div>
                <b-form-select class="form-select" v-model="jsonData.sesso" :options="sessoOptions" disabled> </b-form-select>
              </b-col>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Stato civile</strong>
                </div>
                <b-form-select class="form-select" v-model="jsonData.statoCivile" :options="statoCivileOptions" :value="null"></b-form-select>
              </b-col>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Provincia di residenza</strong>
                </div>
                <b-form-select
                  class="form-select"
                  v-model="jsonData.provinciaResidenza"
                  :options="provinciaResidenzaOptions"
                  :value="null"
                  value-field="value"
                  text-field="text"
                  @change="getSelectedProvinciaResidenza"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong> Comune di residenza</strong>
                </div>
                <b-form-select
                  class="form-select"
                  v-model="jsonData.comuneResidenza"
                  :value="null"
                  value-field="value"
                  :options="comuniResidenzaOptions"
                  text-field="text"
                  style="text-transform: uppercase"
                ></b-form-select>
              </b-col>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Indirizzo di residenza</strong>
                </div>
                <b-form-input v-model="jsonData.indirizzoResidenza" :value="null" value-field="value" text-field="" style="text-transform: uppercase" type="text"></b-form-input>
              </b-col>
            </b-row>
            <b-row v-if="nazionalitaStraniera">
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Nazionalità</strong>
                </div>
                <b-form-select
                  class="form-select"
                  v-model="jsonData.cittadinanza"
                  :options="cittadinanzaOptions"
                  :value="null"
                  value-field="value"
                  text-field="text"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Cellulare</strong>
                </div>
                <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="provincianascita"
                  placeholder="Cellulare"
                  value=""
                  required
                  maxlength="10"
                  :state="validationCellulare"
                  v-model="jsonData.numeroCellulare"
                />
              </b-col>
              <b-col sm class="mb-7 mt-5">
                <div class="h-35px">
                  <strong>Telefono fisso</strong>
                </div>
                <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="provincianascita"
                  placeholder="Telefono fisso"
                  value=""
                  required
                  maxlength="10"
                  :state="validationFisso"
                  v-model="jsonData.numeroFisso"
                />
              </b-col>
            </b-row>
          </div>
          <div class="footer d-flex justify-content-end">
            <b-button variant="light" class="text-primary" @click="onIndietro"> <i class="fas fa-angle-double-left"></i> Indietro </b-button>

            <b-button variant="success" class="ml-2" @click="onAggiungi"> <i class="fas fa-check"></i> Aggiungi </b-button>
          </div>
        </div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
      </b-container>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
export default {
  components: { Loading },
  data() {
    return {
      pathResourceListaProvince: "/api/v2.0/appecupt/comuni/listaprovince",
      pathResourceStatoCivile: "/api/v2.0/appecupt/statocivile",
      pathResourceListaComuni: "/api/v2.0/appecupt/comuni/listacomuni",
      pathResourceListaNazioni: "/api/v2.0/appecupt/nazioni/",
      pathResourceModificaContatto: "/api/v2.0/appecupt/auth/modAssistito",
      pathResourceConvalidaCF: "/api/v2.0/appecupt/codicefiscale/codicefiscaleinverso?scenario=1",
      pathResourceAggiungiContatto: "/api/v2.0/appecupt/contatti/aggiungiContatto",
      jsonData: {
        codiceFiscale: "",
        codiceTS: "",
        numeroCellulare: "",
        numeroFisso: "",
        codiceNazionalita: "",
        controlloStep1: true,
        controlloStep2: true,
        controlloStep3: true,
        provinciaResidenza: {},
        comuneResidenza: {},
      },
      sessoOptions: [
        { value: "M", text: "MASCHIO" },
        { value: "F", text: "FEMMINA" },
      ],
      provinciaResidenzaOptions: [{ value: null, text: "Seleziona la Provincia", disabled: true }],
      cittadinanzaOptions: [{ value: null, text: "Seleziona la cittadinanza", disabled: true }],
      comuniResidenzaOptions: [
        { value: null, text: "Seleziona il Comune", disabled: true },
        {
          value: {
            cap: this.capResidenza,
            codice: this.codIstatComuneResidenza,
            nome: this.comuneResidenza,
            provinciaSigla: this.provinciaResidenzaSigla,
          },
          text: this.comuneResidenza,
        },
      ],
      statoCivileOptions: [{ value: null, text: "Seleziona Stato Civile", disabled: true }],

      token: null,
      nazionalitaStraniera: false,
      isLoading: false,
      codiceFiscaleInserito: false,
    };
  },
  computed: {
    validationCodiceFiscale() {
      var regexCodiceFiscale =
        /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/;
      return this.jsonData.codiceFiscale.length === 0 ? null : regexCodiceFiscale.test(this.jsonData.codiceFiscale) ? true : false;
    },
    validationCodiceTs() {
      var regexCodiceTs = /^([0-9])*$/;
      return this.jsonData.codiceTS.length === 0 ? null : regexCodiceTs.test(this.jsonData.codiceTS) && this.jsonData.codiceTS.length === 5 ? true : false;
    },
    validationCellulare() {
      var regexCellulare = /^3\d{8,9}$/;

      return regexCellulare.test(this.jsonData.numeroCellulare) ? true : false;
    },
    validationFisso() {
      let regexFisso = /^0\d+$/;
      return !this.jsonData.numeroFisso || this.jsonData.numeroFisso.length === 0 ? null : regexFisso.test(this.jsonData.numeroFisso) ? true : false;
    },
  },
  mounted: function () {
    let me = this;
    me.token = sessionStorage.getItem("tokenWSO2");
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.loadListaProvince();
    me.loadStatoCivile();
  },
  watch: {
    "jsonData.codiceFiscale": function (value) {
      this.jsonData.codiceFiscale = value.toUpperCase();
    },
    "jsonData.codiceTS": function () {
      if (this.jsonData.codiceTS.length === 5 && this.validationCodiceFiscale) this.loadInfoContatto();
    },
  },
  methods: {
    loadInfoContatto() {
      let me = this;
      let link = process.env.VUE_APP_URL_BACKEND + me.pathResourceConvalidaCF;
      me.isLoading = true;
      axios
        .post(link, me.jsonData, {
          headers: {
            Authorization: `Bearer ${me.token}`,
          },
        })
        .then((response) => {
          if (response.data.stato === 200 || response.data.stato === 201) {
            me.jsonData = response.data.data;
            me.codiceFiscaleInserito = true;
            me.controlloNazionalita();
            me.isLoading = false;
          } else {
            this.$bvModal
              .msgBoxOk(response.data.errore, {
                title: "Errore",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {})
              .catch((err) => {
                me.isLoading = false;
                console.log(err);
              });
            me.isLoading = false;
          }
        })
        .catch((error) => {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(error, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch(() => {
              me.isLoading = false;
            });
        });
    },
    loadListaProvince() {
      let me = this;
      let link = process.env.VUE_APP_URL_BACKEND + me.pathResourceListaProvince;
      axios
        .get(link, {
          headers: {
            Authorization: `Bearer ${me.token}`,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            me.provinciaResidenzaOptions.push({
              value: element,
              text: element.provincia.toUpperCase(),
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
    loadStatoCivile() {
      let me = this;
      let link = process.env.VUE_APP_URL_BACKEND + me.pathResourceStatoCivile;
      axios
        .get(link, {
          headers: {
            Authorization: `Bearer ${me.token}`,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            me.statoCivileOptions.push({
              value: element,
              text: element.descrizione.toUpperCase(),
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
    getSelectedProvinciaResidenza(provinciaResidenza) {
      let me = this;
      let link = process.env.VUE_APP_URL_BACKEND + me.pathResourceListaComuni;
      me.comuniResidenzaOptions = [{ value: null, text: "Seleziona il Comune", disabled: true }];
      axios
        .post(
          link,
          { codIstat: provinciaResidenza.codIstat },
          {
            headers: {
              Authorization: `Bearer ${me.token}`,
            },
          }
        )
        .then((response) => {
          response.data.data.forEach((element) => {
            me.comuniResidenzaOptions.push({
              value: element,
              text: element.nome.toUpperCase(),
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
    controlloNazionalita() {
      let me = this;
      if (me.jsonData.codiceFiscale != null && me.jsonData.codiceNazionalita !== "100") me.nazionalitaStraniera = true;
      let link = process.env.VUE_APP_URL_BACKEND + me.pathResourceListaNazioni;
      axios
        .get(link, {
          headers: {
            Authorization: `Bearer ${me.token}`,
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            me.cittadinanzaOptions.push({
              value: element,
              text: element.descrizione,
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
    onAggiungi() {
      let me = this;
      let link = process.env.VUE_APP_URL_BACKEND + me.pathResourceAggiungiContatto;
      const datiContatto = {
        codiceFiscale: me.jsonData.codiceFiscale,
        codiceTS: me.jsonData.codiceTS,
        controlloStep2: me.jsonData.controlloStep2,
        controlloStep3: me.jsonData.controlloStep3,
        nome: me.jsonData.nome,
        cognome: me.jsonData.cognome,
        dataNascita: me.jsonData.dataNascita,
        sesso: me.jsonData.sesso,
        scadenzaTS: me.jsonData.scadenzaTS,
        luogoDiNascita: me.jsonData.luogoDiNascita,
        istatLuogoDiNascita: me.jsonData.istatLuogoDiNascita,
        controlloStep1: me.jsonData.controlloStep1,
        statoCivile: me.jsonData.statoCivile.descrizione,
        codStatoCivile: me.jsonData.statoCivile.id,
        provinciaResidenza: me.jsonData.provinciaResidenza.provincia,
        codIstatProvinciaResidenza: me.jsonData.provinciaResidenza.codIstat,
        comuneResidenza: me.jsonData.comuneResidenza.nome,
        codIstatComuneResidenza: me.jsonData.comuneResidenza.codice,
        provinciaResidenzaSigla: me.jsonData.comuneResidenza.provinciaSigla,
        strutturaPreferita: "150901",
        istatCittadinanza: me.jsonData.codiceFiscale.substr(11, 1) === "Z" ? me.jsonData.cittadinanza.istat : me.jsonData.codiceNazionalita,
        indirizzoResidenza: me.jsonData.indirizzoResidenza,
        capResidenza: me.jsonData.comuneResidenza.cap,
        cittadinanza: me.jsonData.codiceFiscale.substr(11, 1) === "Z" ? me.jsonData.cittadinanza.descrizione : "ITALIA",
        terminiServizio: me.jsonData.terminiServizio,
        numeroCellulare: me.jsonData.numeroCellulare,
        numeroFisso: me.jsonData.numeroFisso,
        codiceNazionalita: me.jsonData.codiceNazionalita,
      };
      me.isLoading = true;
      axios
        .post(link, datiContatto, {
          headers: {
            versioneapp: "5",
            //Authorization: `Bearer ${me.token}`,
            "x-access-token": me.tokenLogin,
          },
        })
        .then((response) => {
          if (response.data.stato === 201) {
            me.isLoading = false;
            this.$bvModal
              .msgBoxOk(response.data.data.messaggioSuccessoRegistrazione, {
                title: "Congratulazioni",
                size: "md",
                okVariant: "outline-success",
                headerClass: "vv-msg-header-success",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
                me.$emit("onIndietro");
                me.isLoading = false;
              })
              .catch((err) => {
                me.isLoading = false;
                console.log(err);
              });
          } else {
            this.$bvModal
              .msgBoxOk(response.data.errore, {
                title: "Errore",
                size: "md",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {})
              .catch((err) => {
                me.isLoading = false;
                console.log(err);
              });
            me.isLoading = false;
          }
        })
        .catch((err) => {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(err, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch(() => {});
        });
    },
    onIndietro() {
      let me = this;
      me.$emit("onIndietro");
    },
  },
};
</script>
